import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Paper from 'material-ui/Paper';
import CenteredCol from './shared/CenteredCol';
import { vAlignCenter } from '../style';

const About = props => (
    <section>
        <Grid fluid>
            <Row>
                <Col xs={12}>
                    <Row center="xs">
                        <Col xs={12} sm={6} style={{paddingTop: "2rem"}}>
                            <CenteredCol>
                                <img style={{marginTop: "5%"}} src="img/logo.jpg" />
                            </CenteredCol>
                            <h3 style={{fontWeight: 300}}>Winter, spring, summer and fall...we do it all!</h3>
                            <p style={{textAlign: "justify"}}>
                                Our company was founded in 1999, serving the Atlanta area. Our values are based on the belief that our customer’s needs are of the utmost importance and our team is committed to meeting those needs. As a result, a high percentage of our business is from repeat happy customers and referrals. We would welcome the opportunity to earn your trust and deliver you the best service in the industry.
                            </p>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Grid>
    </section>
);

export default About;


// WEBPACK FOOTER //
// ./src/components/About.js